import { render, staticRenderFns } from "./profile-actualize-shift.vue?vue&type=template&id=d24c4efa&scoped=true&"
import script from "./profile-actualize-shift.vue?vue&type=script&lang=js&"
export * from "./profile-actualize-shift.vue?vue&type=script&lang=js&"
import style0 from "./profile-actualize-shift.vue?vue&type=style&index=0&id=d24c4efa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24c4efa",
  null
  
)

export default component.exports